var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.6,34.8L0,48l13.1-2.5l25.2-25.2L27.7,9.6L2.6,34.8z M11.7,42.7l-4.1,0.8l-3.1-3.1l0.8-4.1l0,0L11.7,42.7L11.7,42.7z  M13.9,40.5l-6.4-6.4l20.2-20.2l6.4,6.4L13.9,40.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2,0.2l-7.4,7.4l10.6,10.6l7.4-7.4L37.2,0.2z M34,7.6l3.1-3.1l6.4,6.4L40.4,14L34,7.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditB);
export default __webpack_public_path__ + "static/media/edit-b.75b877994b880d417800d35cf58783bc.svg";
export { ForwardRef as ReactComponent };